import { TRADEMARK_SERVICE_KEYS } from '_constants/trademarkServices';
import { PROCESSING_OPTIONS_KEYS } from '_constants/processing';
import { PRODUCT_CODES } from '_constants/products';

export const getBasePackage = (trademarkServiceKey, processingOptionKey) => {
  const MAP = {
    [TRADEMARK_SERVICE_KEYS.trademarkRegistration]: {
      [PROCESSING_OPTIONS_KEYS.basic]: [
        PRODUCT_CODES.tmRegisterTrademark,
        PRODUCT_CODES.tmSearchBasic,
        PRODUCT_CODES.tmMonitoring,
        // PRODUCT_CODES.tmRushProcessing,
      ],
      [PROCESSING_OPTIONS_KEYS.deluxe]: [
        PRODUCT_CODES.tmRegisterTrademark,
        PRODUCT_CODES.tmSearchFederalState,
        PRODUCT_CODES.tmMonitoring,
        // PRODUCT_CODES.tmRushProcessing,
      ],
      [PROCESSING_OPTIONS_KEYS.premier]: [
        PRODUCT_CODES.tmRegisterTrademark,
        PRODUCT_CODES.tmSearchFederalState,
        PRODUCT_CODES.tmMonitoring,
        PRODUCT_CODES.tmOfficeActionResponse,
        // PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.comprehensiveTrademarkSearch]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmSearchFederalState,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.statementOfUse]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmStatementOfUse,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.trademarkMonitoring]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmMonitoring,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.officeActionResponse]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmOfficeActionResponse,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.trademarkRenewal]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmRenewal,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.requestExtension]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmExtension,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.trademarkRevive]: {
      [PROCESSING_OPTIONS_KEYS.standard]: [
        PRODUCT_CODES.tmRevivalFromAbandonment,
        PRODUCT_CODES.tmRushProcessing,
      ],
    },
    [TRADEMARK_SERVICE_KEYS.logoDesignService]: {
      [PROCESSING_OPTIONS_KEYS.basic]: [
        PRODUCT_CODES.tmLogoDesignService,
        // PRODUCT_CODES.tmRushProcessing,
      ],
      [PROCESSING_OPTIONS_KEYS.standardPackage]: [
        PRODUCT_CODES.tmLogoDesignService,
        // PRODUCT_CODES.tmRushProcessing,
      ],
      [PROCESSING_OPTIONS_KEYS.ultimate]: [
        PRODUCT_CODES.tmLogoDesignService,
        // PRODUCT_CODES.tmRushProcessing,
      ],
    },
  };

  const mapNarrowedByServiceKey = MAP[trademarkServiceKey];
  return mapNarrowedByServiceKey
    ? mapNarrowedByServiceKey[processingOptionKey] || []
    : [];
};
